import { Avatar, Typography } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import photo1 from '../../../public/webp/fromPNG/AlgeaTheme/services/img_1.webp';
import photo2 from '../../../public/webp/fromPNG/AlgeaTheme/services/img_2.webp';
import photo3 from '../../../public/webp/fromPNG/AlgeaTheme/services/img_3.webp';
import photo4 from '../../../public/webp/fromPNG/AlgeaTheme/services/img_4.webp';
import photo5 from '../../../public/webp/fromPNG/AlgeaTheme/services/img_5.webp';
import avatar from '../../../public/webp/fromPNG/AlgeaTheme/services/mitchell.webp';
import citationSymbol from '../../../public/webp/fromPNG/AlgeaTheme/services/quote-img.webp';
import { scrollToElement } from '../../../utils/handleScroll';
import { StyledSpan } from '../../homePageDesign23/Hero/styles';
import { servicesContactFormId } from '../Services.consts';
import {
  StyledAvatarBoxMargin,
  StyledAvatarJob,
  StyledCitationWrapper,
  StyledDescription,
  TextStyledStack,
  StyledPhoto1,
  StyledPhoto2,
  StyledPhoto3,
  StyledPhoto4,
  StyledPhoto5,
  StyledPhotoGrid,
  StyledTitle,
  StyledButton,
  StyledVerticalDivider,
  StyledHorizontalDivider,
} from './styles';
import { StaticImageData } from 'next/image';

const Citation = () => {
  return (
    <StyledCitationWrapper>
      <img
        alt="citation"
        src={(citationSymbol as unknown as StaticImageData).src}
      />
      <Typography
        variant="strong_600"
        sx={(theme) => ({
          color: theme.palette.invertedContent?.PRIMARY,
        })}>
        The developers at Rumble Fish Software Development are professional and
        capable of producing the highest quality code.
      </Typography>
      <StyledAvatarBoxMargin
        direction="row"
        spacing={2}
        divider={<StyledVerticalDivider orientation="vertical" flexItem />}>
        <Avatar
          alt="Mitchell Maddox"
          src={(avatar as unknown as StaticImageData).src}
          sx={{ width: 60, height: 60 }}
        />
        <div>
          <Typography
            variant="regular_500"
            sx={(theme) => ({
              color: theme.palette.invertedContent?.PRIMARY,
            })}>
            Mitchell Maddox
          </Typography>
          <StyledAvatarJob
            variant="regular_400"
            sx={(theme) => ({
              color: theme.palette.invertedContent?.SECONDARY,
            })}>
            <br />
            COO of SpaceInch
          </StyledAvatarJob>
        </div>
      </StyledAvatarBoxMargin>
    </StyledCitationWrapper>
  );
};

export const BuildingExpertise = () => {
  return (
    <>
      <Section width="normal">
        <TextStyledStack>
          <StyledTitle variant="display_md">
            You bring the product vision. We bring product building expertise.
          </StyledTitle>

          <StyledDescription paragraph variant="strong_500">
            Rumble Fish helps entrepreneurs build and launch{' '}
            <StyledSpan variant="strong_500">new software products.</StyledSpan>{' '}
            We deliver on-demand a ready-to-go developers team.
          </StyledDescription>

          <StyledButton
            variant="primary"
            onClick={() => scrollToElement(servicesContactFormId)}>
            Estimate project
          </StyledButton>
        </TextStyledStack>

        <StyledPhotoGrid>
          <StyledPhoto1
            alt="programmers"
            src={(photo1 as unknown as StaticImageData).src}
          />
          <StyledPhoto2
            alt="programmers"
            src={(photo2 as unknown as StaticImageData).src}
          />
          <StyledPhoto3
            alt="programmers"
            src={(photo3 as unknown as StaticImageData).src}
          />
          <StyledPhoto4
            alt="programmers"
            src={(photo4 as unknown as StaticImageData).src}
          />
          <StyledPhoto5
            alt="programmers"
            src={(photo5 as unknown as StaticImageData).src}
          />
          <Citation />
        </StyledPhotoGrid>
      </Section>
      <StyledHorizontalDivider flexItem />
    </>
  );
};
